import React from "react";
import Sanwe from "./Sanwe";
import Mouta from "./Mouta";
import Trbwe from "./Trbwe";
import Jame3e from "./Jame3e";
import Mahni from "./Mahni";
import Lang from "./Lang";
import Projet from "./Projet";
import Nadawe from "./Nadawe";

const Home = ({addToCart, addToFavorites}) => {
    return (
      <div className="main">
        <div className="main-text">
          <h1>
            <span>أهلا بكم</span>  في مركزنا</h1>
          <p className="ppp">
            &nbsp; &nbsp; &nbsp;
            <br />المركز الخصوصي للتعليم والتدريب يدعم الطلاب في جميع المراحل التعليمية والمهنية
            <br />&nbsp; &nbsp; &nbsp;عبر برامج شاملة تشمل التعليم، التدريب، الدورات، والدعم الأكاديمي
            <br />بهدف بناء مستقبل ناجح بخبرة فريق متخصص وأساليب حديثة
        <br/> <br/>
          </p>
        </div>
        <div className="first-image">
          <img src="https://i.postimg.cc/q7XJytC4/Logo.jpg" className="mm" alt="Logo" />
        </div>
        <br></br><br/><br/><br></br><br></br><br></br><br></br><br></br><br></br>
        <Sanwe />
        <br/><br/>
        <Mouta/>
         <br/><br/>
        <Trbwe/>
         <br/><br/>
        <Jame3e/>
         <br/><br/>
        <Mahni/>
         <br/><br/>
        <Lang/>
         <br/><br/>
        <Projet/>
        <br/><br/>
        <Nadawe/>
        
        <br/><br/>
        
    
      </div>
    );
  };
  
  export default Home;